import { render, staticRenderFns } from "./BidBoxComponent.vue?vue&type=template&id=7cd85e10&"
import script from "./BidBoxComponent.vue?vue&type=script&lang=js&"
export * from "./BidBoxComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports